import React from "react";
import "../../styles/skeleton.css";

export function Skeleton({ width, height, radius = 8, style = {} }) {
  return (
    <div
      className="gs-skeleton"
      style={{ width, height, borderRadius: radius, ...style }}
    />
  );
}

export function SkeletonStatCard() {
  return (
    <div className="gs-skeleton-card">
      <Skeleton width={40} height={40} radius={10} />
      <Skeleton width="55%" height={28} radius={6} style={{ marginTop: "0.75rem" }} />
      <Skeleton width="75%" height={14} radius={4} style={{ marginTop: "0.4rem" }} />
    </div>
  );
}

export function SkeletonTextBlock({ lines = 3, style = {} }) {
  const widths = ["100%", "85%", "65%", "90%", "70%"];
  return (
    <div className="gs-skeleton-text-block" style={style}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={widths[i % widths.length]} height={14} radius={4} />
      ))}
    </div>
  );
}

export function SkeletonCard({ children, style = {} }) {
  return (
    <div className="gs-skeleton-card" style={style}>
      {children}
    </div>
  );
}
